import React from 'react';
import styled from 'styled-components';
import { FaExclamationTriangle } from 'react-icons/fa';

const EmergencyPageContainer = styled.div`
  max-width: 800px;
  margin: 5rem auto;
  padding: 3rem;
  background-color: #fffbe6;
  border: 2px solid #ffc107;
  border-radius: 8px;
  text-align: center;
`;

const IconWrapper = styled.div`
  font-size: 4rem;
  color: #d9534f;
  margin-bottom: 1.5rem;
`;

const Title = styled.h1`
  font-size: 2.5rem;
  color: #d9534f;
  margin-bottom: 1rem;
`;

const Message = styled.p`
  font-size: 1.2rem;
  line-height: 1.8;
  color: #333;
`;

const EmergencyInfo = () => {
    return (
        <EmergencyPageContainer>
            <IconWrapper>
                <FaExclamationTriangle />
            </IconWrapper>
            <Title>Medical Emergency Warning</Title>
            <Message>
                Based on the symptoms you have selected, you may be experiencing a medical emergency.
                Your order has been automatically cancelled and refunded.
            </Message>
            <Message><strong>Please call 999 or attend your nearest A&E department immediately.</strong></Message>
        </EmergencyPageContainer>
    );
};

export default EmergencyInfo;